<template>
  <b-sidebar
    id="sidebar-create-quote"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Quote') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="quoteCreate">
          <fieldset-component :title="$t('Direction')">
            <b-row>
              <b-col md="12">
                <!-- Direction -->

                <validation-provider
                  #default="{ errors }"
                  :name="$t('Direction')"
                  rules="required"
                >
                  <v-select
                    id="direction"
                    v-model="quote.direction"
                    :reduce="(option) => option.id"
                    :options="directions"
                    :get-option-label="(option) => option.code + ' - ' + $langName(option.name)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
          </fieldset-component>

          <fieldset-component
            v-if="!isTargeted()"
            :title="$t('Scientific potential of the institute')"
          >
            <b-row>
              <b-col
                md="6"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Dc amount')"
                  rules="required|integer"
                >
                  <!-- Dc amount -->
                  <b-form-group
                    :label="$t('Dc amount')"
                    label-for="dcAmount"
                  >
                    <b-form-input
                      id="dcAmount"
                      v-model="quote.dc_amount"
                      trim
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col
                md="6"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Phd amount')"
                  rules="required|integer"
                >
                  <!-- Phd amount -->
                  <b-form-group
                    :label="$t('Phd amount')"
                    label-for="phdAmount"
                  >
                    <b-form-input
                      id="phdAmount"
                      v-model="quote.phd_amount"
                      trim
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
          </fieldset-component>
          <fieldset-component
            v-if="!isTargeted()"
            :title="$t('Number of students at the institute')"
          >
            <b-row>
              <b-col
                md="6"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Dc student')"
                  rules="required|integer"
                >
                  <!-- Dc amount -->
                  <b-form-group
                    :label="$t('Dc student')"
                    label-for="dcStudent"
                  >
                    <b-form-input
                      id="dcStudent"
                      v-model="quote.dc_student"
                      trim
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col
                md="6"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Phd student')"
                  rules="required|integer"
                >
                  <!-- Phd amount -->
                  <b-form-group
                    :label="$t('Phd student')"
                    label-for="phdStudent"
                  >
                    <b-form-input
                      id="phdStudent"
                      v-model="quote.phd_student"
                      trim
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col
                md="6"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Independent student')"
                  rules="required|integer"
                >
                  <!-- Phd amount -->
                  <b-form-group
                    :label="$t('Independent student')"
                    label-for="independentStudent"
                  >
                    <b-form-input
                      id="independentStudent"
                      v-model="quote.independent_student"
                      trim
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
          </fieldset-component>
          <fieldset-component :title="$t('The need for specialization for {year}', { year: letter.period.admission_year})">
            <b-row>
              <b-col
                v-for="dcType in dcTypes"
                :key="dcType.id"
                md="6"
              >
                <!-- DcTypes -->
                <b-form-group
                  :label="$langName(dcType.name)"
                  label-for="dcType"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$langName(dcType.name)"
                    rules="required"
                  >
                    <b-form-input
                      :id="'dcType'+dcType.id"
                      v-model="quote.dc_type[dcType.id]"
                      trim
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </fieldset-component>

        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="quote.id ? 'primary' : 'success'"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ quote.id ? $t('Update Quote') : $t('Create Quote') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BSidebar, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, integer, minValue } from '@/libs/validations/validations'
import FieldsetComponent from '@/views/components/FieldsetComponent.vue'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    FieldsetComponent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      minValue,
    }
  },
  computed: {
    quote: {
      get() {
        return this.$store.state.quote.quote
      },
      set(data) {
        this.$store.commit('quote/UPDATE', data)
      },
    },
    letter() {
      return this.$store.state.letter.letter
    },
    directions() {
      return this.$store.state.quote.directions
    },
    dcTypes() {
      return this.$store.getters[this.isTargeted() ? 'staticModule/getTargetedDcTypes' : 'staticModule/getSimpleDcTypes']
    },
  },
  created() {
    const MODULE_NAME = 'quote'
    this.$store.dispatch(`${MODULE_NAME}/directions`, this.isTargeted() ? this.letter.to_org.id : this.letter.from_org.id)
    localize(this.$i18n.locale)
  },
  methods: {
    isTargeted() {
      return (this.letter.letter_type === this.$store.state.staticModule.letterTypeTargeted)
    },
    getQuoteType(id) {
      return this.$store.getters['staticModule/getQuoteType'](id)
    },
    clear(hide) {
      this.$store.commit('quote/FRESH', this.$route.params.id)
      this.$refs.quoteCreate.reset()
      hide()
    },
    submit(hide) {
      this.$refs.quoteCreate.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.quote, `quote/${this.quote.id ? 'update' : 'create'}`, () => {
            this.$emit('refetchData')
            this.clear()
          })
          hide()
        }
      })
    },
  },
}
</script>

<style>
  #sidebar-create-quote {
    width: 50rem;
  }
</style>
